import 'jquery';
import 'jquery.cookie';
import 'bootstrap';
import 'rails-ujs';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './polyfills';
import 'events-polyfill';

import '../../src/javascripts/utils/prepopulated_input';
import '../../src/javascripts/utils/date_time_input';
import '../../src/javascripts/utils/resizer';
import '../../src/javascripts/utils/tippy';

import '../../src/javascripts/shared/adtech';
import '../../src/javascripts/shared/constants';
import '../../src/javascripts/shared/defer_load';
import '../../src/javascripts/shared/details';
import '../../src/javascripts/shared/modal';
import '../../src/javascripts/shared/search';

import '../../src/javascripts/b_style/font-awesome';
import '../../src/javascripts/b_style/b_style';
import '../../src/javascripts/b_style/feefo';
import '../../src/javascripts/b_style/nav';
import '../../src/javascripts/b_style/accordion';
import '../../src/javascripts/b_style/supplier';

require.context('../../images', true);
